import { resetFTOSlice } from '../features/FTO/slices/FTOSlice';
import { resetInfringementDetectionSlice } from '../features/InfringementDetection/slices/infringementDetectionSlice';
import { resetAppSlice } from '../redux/slices/appSlice';
import { resetDrawerSlice } from '../redux/slices/drawerPatentSlice';
import { resetIDSlice } from '../redux/slices/inventionDisclosureSlice';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resetReduxState = (dispatch: any) => {
  dispatch(resetAppSlice());
  dispatch(resetIDSlice());
  dispatch(resetFTOSlice());
  dispatch(resetInfringementDetectionSlice());
  dispatch(resetDrawerSlice());
};
